module.exports = "/images/arrow-right-grey.png?4a83c12556743378c0e7fb72afbc3837";